import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogRef, DialogService, KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { TranslationPipe } from '@raptor-fe/services';
import { LanguageModalStore } from './store/language-modal.store';
import { CustomFilterPipe } from '@raptor-fe/core';

@Component({
    selector: 'lib-web-language-modal',
    template: `
        <kendo-dialog            
            minWidth="80vw"
            (close)="onClose()"
            autoFocusedElement="#branch-search-input"
        >
            <kendo-dialog-titlebar>
                <i class="bi bi-translate me-2"></i>
                <h6>{{ { feature: "Common", component: "Modal", label: "Change Language" } | translate }}</h6>
            </kendo-dialog-titlebar>

            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-12 px-3 border rounded-md bg-body">
                        <input
                            id="branch-search-input"
                            class="input-sm my-2 form-control"
                            placeholder="{{ { feature: 'Common', component: 'Modal', label: 'Search Languages' } | translate }}"
                            (keydown)="search($event)"
                        />
                        <div class="border-bottom py-2">
                            <span>
                                {{ { feature: "Common", component: "Modal", label: "Current Language" } | translate }}:
                                <b>{{ store.currentLanguage().name }}</b>
                            </span>
                        </div>
                        <ul>
                            @for (entry of store.languageList() | filter: store.filterTerm(); track entry) {
                            <li class="row border-bottom py-2" aria-hidden="true" (click)="store.updateNewLanguage(entry.id)">
                                <div class="row">
                                    <div class="col-md-10">
                                        {{ entry.name }}
                                    </div>
                                    <div class="col-md-2">
                                        <input type="radio" name="branch" [checked]="entry.id === store.newLanguage().id"/>
                                    </div>
                                </div>
                            </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>

             <kendo-dialog-actions layout="end">
                @if(store.errorMessage()) {
                    <span class="text-danger me-auto">{{ store.errorMessage() }}</span>
                }
                <button
                    class="btn btn-sm btn-secondary min-w-24"
                    (click)="onClose()"
                    [disabled]="store.isLoading()"
                >
                    {{ { feature: "Common", component: "Button", label: "Cancel" } | translate }}
                </button>
                <button class="btn btn-sm btn-primary min-w-24" (click)="store.getTranslations(store.newLanguage())" [disabled]="store.isLoading()">
                    @if(!store.isLoading()) {
                    {{ { feature: "Common", component: "Button", label: "Confirm" } | translate }}
                    }
                    @else {
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    }
                </button>
            </kendo-dialog-actions>

        </kendo-dialog>

    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslationPipe, CustomFilterPipe, KENDO_DIALOGS],
    providers: [LanguageModalStore],
})
export class WebLanguageModalComponent {
    protected readonly store = inject(LanguageModalStore);
    // keep a reference to the dialog
    protected readonly dialogRef = inject(DialogRef);

    search(event: KeyboardEvent): void {
        const searchText = event.target as HTMLInputElement;
        this.store.updateSearchTerm(searchText.value ?? '');
    }

    protected async onClose(): Promise<void> {
        this.dialogRef.close();
    }

    public static open(dialogService: DialogService): void {
        dialogService.open({
            content: WebLanguageModalComponent,
            width: '80vw',
        });
    }
}
